export default __webpack_public_path__ + "static/media/oscer-pres-difficulty-sleeping.959cd20f.svg";